<template>
<div id="publicExportWrap">
  <el-button @click="openDialog">{{exportBtnText}}</el-button>
  <el-button type="text" @click="handleGoExportHistory">{{exportHistoryBtnText}}</el-button>
  <el-dialog
    :title="exportTitle"
    :visible.sync="exportDialogVisible"
    :before-close="handleClose"
    destroy-on-close
    width="70%">
    <el-steps :active="active" align-center process-status="process" finish-status="success">
      <el-step title="确认导出结果" />
      <el-step title="等待处理" />
    </el-steps>
    <step-one
      v-if="active === 0"
      :newSearchParams="exportSearchParams"
      :columns="columns"
      @openHistory="handleGoExportHistory"
    />
    <div v-else class="step-two">
      <p class="desc">开始导出，请在 <a @click="handleGoExportHistory">导出历史</a> 中确认导出结果</p>
    </div>
    <div v-show="active === 0" slot="footer" class="dialog-footer">
      <div>
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="exportData" :loading="loading">导出</el-button>
      </div>
    </div>
    <div v-show="active === 1" slot="footer">
      <div></div>
      <div>
        <el-button @click="handleGoExportHistory">导出历史</el-button>
        <el-button type="primary" @click="handleClose">完 成</el-button>
      </div>
    </div>
  </el-dialog>
  <export-history :visible="drawerVisible" @updateVisible="changeDrawerVisible"></export-history>
</div>
</template>
<script setup>
import { ref, watch } from 'vue'
import stepOne from './stepOne'
import exportHistory from './exportHistory.vue'
import * as exportApi from '@/api/export'
import { Message } from 'element-ui'

const props = defineProps({
  /**
   * 筛选项数据
   */
  searchData: {
    type: Object,
    default: () => ({}),
  },
  exportBtnText: {
    type: String,
    default: '导出数据',
  },
  exportHistoryBtnText: {
    type: String,
    default: '查询导出结果',
  },
  /**
   * 导出弹窗标题
   */
  exportTitle: {
    type: String,
    default: '导出数据',
  },
  /**
   * 可导出字段
   * [{name: '', label: ''}]
   */
  columns: {
    type: Array,
    default: () => [],
  },
  /**
   * 是否可以导出，为true则可以导出，为false为不能导出
   * 如果是函数的话，看函数的返回值
   */
  canExport: {
    type: [Boolean, Function],
    default: true,
  },
  /**
   * 导出模版，主要用于导出接口api
   */
  exportTemplate: {
    type: String,
    default: '',
  },
  /**
   * 获取查询条件的函数
   */
  getSearchCondition: {
    type: Function,
  },
})

const loading = ref(false)
const active = ref(0)
const drawerVisible = ref(false)
const exportDialogVisible = ref(false)
const exportSearchParams = ref([])

watch(exportDialogVisible, (newValue) => {
  if (newValue) {
    active.value = 0
    exportSearchParams.value.splice(0, exportSearchParams.value.length, ...props.getSearchCondition())
  }
}, { immediate: true })

function openDialog() {
  if (typeof props.canExport === 'boolean') {
    exportDialogVisible.value = props.canExport
  } else {
    exportDialogVisible.value = props.canExport()
  }
}

function handleClose() {
  exportDialogVisible.value = false
}

function handleGoExportHistory() {
  drawerVisible.value = true
}

function exportData() {
  loading.value = true
  exportApi[`export${props.exportTemplate}`](props.searchData).then(() => {
    active.value = 1
  }).catch(() => {
    Message({
      type: 'error',
      message: '导出接口异常',
    })
  }).finally(() => { loading.value = false })
}

function changeDrawerVisible(state) {
  drawerVisible.value = state
}
</script>
<script>
export default {
  name: 'PublicExport',
}
</script>

<style lang="scss" scoped>
::v-deep .el-steps {
  margin-bottom: 20px;
  // box-shadow: 0px 10px 14px -6px #888888;
}
#publicExportWrap{
  display: inline-block;
  ::v-deep .el-form-item {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    margin-right: 0px;
    width: 100%;
    .el-form-item__label{
      text-align: center;
      width: 100px;
      margin-right: 12px;
      padding-right: 0px;
    }
    .el-form-item__content{
      width: 100%;
      margin-left: 0px;
    }
  }
}
.offline-export-tips {
  color: #FF9C2A;
  font-weight: bold;
}
.BLM-icon-info {
  color:#FF9C2A;
  margin-right: 10px;
}
.step-two {
  height: 300px;
  .desc {
    display: flex;
    justify-content: center;
  }
}
</style>
